import { init } from './init'
import { dispatch } from './dispatch'

export const mutations = Object.assign({}, init, dispatch)
